import React from 'react'
import styled from 'styled-components'
import OuterLink from '../../atoms/OuterLink'

const Item = styled.li`
  list-style: none;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    margin: 0px 12px;
  }
`

const ItemLink = styled(OuterLink)`
  text-decoration: underline;
`

const ItemText = styled.div`
  line-height: 100%;
  font-weight: 600;
  font-size: 16px;
  white-space: nowrap;
  color: ${({ theme }) => theme.palette.font.main};
  @media (max-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    padding: 9px;
    justify-content: center;
  }
`

export default function PastPageItem({ text, to }: { text: string; to: string }) {
  return (
    <Item>
      <ItemLink to={to}>
        <ItemText>{text}</ItemText>
      </ItemLink>
    </Item>
  )
}
